namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmZpusobDoruceni extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmZpusobDoruceniReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmZpusobDoruceniObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmZpusobDoruceniObj());
            this.detailObj.createBase({
                contentName: "detailAdmZpusobDoruceni",
                contentCaption: "jres:33000517", //RC 33000517 : Způsob doručení
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmZpusobDoruceni", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmZpusobDoruceniObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmZpusobDoruceniReadDto> {

        create() {
            this.data["gener_automat"] = 1;
        }

        textPopis(): string | undefined | null {
            return this.data["zpusob_dor_txt"]
        }

        setSxsDetail(): string {
            return this.data.zpusob_dor + "#";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmZpusobDoruceniSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (data.NewRecord == true)
                data.zpusob_dor = null;
            if (this.data.povol_sl) {
                if (this.data["povol_sl"].indexOf('#') >= 0) {
                    this.cnt.dialogs.confirm("jres:33000257", "jres:33000258").on("yes", () => { //RC 33000258 : Povolené služby obsahovali znak '#'. Přejete si ho ponechat mezi povolenými službami?
                        if (data.povol_sl == null || data.povol_sl == "")
                            data.povol_sl = "#"
                        else
                            data.povol_sl += ",#"
                        this.saveDataInternal(data, close)
                    }).on("no", () => {
                        this.saveDataInternal(data, close)
                    })
                } else {
                    this.saveDataInternal(data, close)
                }
            }
        }

        private saveDataInternal(data: Gordic.AdmIsl.Interface.GAdmZpusobDoruceniSaveDto, close: boolean) {
            (this.cnt.isl.AdmZpusobDoruceni.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmZpusobDoruceni", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmZpusobDoruceni.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.zpusob_dor_txt) ? this.data.zpusob_dor_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenSslDenik?.update({ visible: editMode == false })
        }

        createForm() {
            var _cnt = this.cnt;
            this.MakeField("zpusob_dor", {
                emptyValue: null,
                defaultValue: 0,
            });
            this.MakeField("zpusob_dor_txt");
            this.MakeField("k_xml");
            //this.MakeBoolField("povol_sl_hash", {
            //    model: function (op, dto, modelOptions) {
            //        switch (op) {
            //            case "apply":
            //                if (dto['povol_sl'] == "#")
            //                    $(this).gfield("setValue", true)
            //                break;
            //            case "collect":
            //                if ($(this).gfield("getValue") == true)
            //                    dto["povol_sl"] = "#";
            //        }
            //    },
            //    change: (ev, ctx) => {
            //        var povolHash = this.cnt.findFields("povol_sl_hash").gfield("getValue");
            //        var favoriteKomb = this.cnt.findFields("favorite_komb");
            //        var povolSlKomb = this.cnt.findFields("povol_sl_komb");
            //        var povolSlMulti = this.cnt.findFields("povol_sl_multi");
            //        favoriteKomb.gfield("disable");
            //        povolSlKomb.gfield("disable");
            //        povolSlMulti.gfield("disable");
            //        if (povolHash == false) {
            //            favoriteKomb.gfield("enable");
            //            if (favoriteKomb.gfield("getValue") == false)
            //                povolSlMulti.gfield("enable");
            //            else
            //                povolSlKomb.gfield("enable");
            //        }
            //    }
            //})
            this.MakeBoolField("favorite_komb", {
                change: (ev, ctx) => {
                    if (this.editMode == true) {
                        var form = this.cnt.findForms("{0}form".format(this.options.contentName));
                        var kombSl = form.findFields("povol_sl_komb")
                        var multiSl = form.findFields("povol_sl_multi")
                        if (ctx.value == true) {
                            this.data["favorite_komb"] = 1;
                            kombSl.gfield("enable");
                            multiSl.gfield("disable");
                        } else {
                            this.data["favorite_komb"] = 0;
                            kombSl.gfield("disable");
                            multiSl.gfield("enable");
                        }
                    }
                }
            })
            this.MakeSelectField("povol_sl_komb", Gordic.Prefabs.Select.admWflsksl(), {  // Prefab pro wflsksl
                model: function (op, dto, modelOptions) {
                    switch (op) {
                        case "apply":
                            if (dto["favorite_komb"] == 1) {
                                if (dto["povol_sl"])
                                    $(this).gfield("setValue", { komb_sluzeb: dto["povol_sl"]}, { valid: false })
                            }
                            break;
                        case "collect":
                           // if (_cnt.findFields("povol_sl_hash").gfield("getValue") == false) {
                                if (dto["favorite_komb"] == 1) {
                                    var data = $(this).gfield("getValue");
                                    if (data != null)
                                        dto["povol_sl"] = data.komb_sluzeb
                                    else
                                        dto["povol_sl"] = "";
                                }
                            //}
                            break;
                    }
                }
            });
            this.MakeSelectField("povol_sl_multi", Gordic.Prefabs.Select.wflcpos(), {
                multi: true,
                dropdown: false,
                itemWidth: "",
                model: function (op, dto, modelOptions) {
                    switch (op) {
                        case "apply":
                            if (dto["favorite_komb"] == 0) {
                                if (dto["povol_sl"])
                                    $(this).gfield("setValue", dto["povol_sl"].split(',').filter((sl) => { return sl != "#" }).map(obj => ({
                                        post_sluzba: parseInt(obj)
                                    })), { valid: false })
                            }
                            break;
                        case "collect":
                            //if (_cnt.findFields("povol_sl_hash").gfield("getValue") == false) {
                                if (dto["favorite_komb"] == 0) {
                                    var data = $(this).gfield("getValue");
                                    var dataArr: any[] = []
                                    data.forEach((item) => {
                                        dataArr.push(item.post_sluzba)
                                    })
                                    dataArr.sort((a, b) => { return a - b });
                                    dto["povol_sl"] = dataArr.join(',')
                                }
                                break;
                            //}
                    }
                }
            });
            this.MakeSelectField("ktg_zp_dor", Gordic.Prefabs.Select.admWflckzd(), { model: "model.ktg_zp_dor=value.ktg_zp_dor" })
            this.MakeSelectField("priz_pro_doruc", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_pro_doruc=value.priz_an" })
            this.MakeSelectField("priz_pro_odes", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_pro_odes=value.priz_an" })
            this.MakeSelectField("ixs_su_evyp", Gordic.Prefabs.Select.ginspod(), { model: "model.ixs_su_evyp=value.ixs_su" })
            this.MakeSelectField("ixs_fun_evyp", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ixs_fun_evyp=value.ixs_fun",
                serverFilters: {
                    ixs_su: new Gordic.Forms.Dependency("ixs_su_evyp", "ixs_su", true, false, this.cnt.element)
                }
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt())
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }
    }
}